module.exports = __webpack_public_path__ + "img/stop-hearing.3a33ab43.svg";